import Container from '@/components/@base/container';
import { Text } from '@/components/@base/typography';
import localization from '@/constant/localization';
import { SIZE_ENUM } from '@/components/@base/@types';
import FontIcon from '@/components/@base/font-icon';
import Button from '@/components/@base/button';

const NotFound = () => {
  const handleRedirect = () => {
    if(localStorage.getItem('merchantRedirectURL')) {
      location.replace(localStorage.getItem('merchantRedirectURL')!);
    } else  history.back()
  }
  return (
    <Container
      center
      className='h-[100vh] max-w-[448px] mx-auto w-full flex-col gap-3 bg-grayLight-0 dark:bg-grayDark-950 px-6 i5:px-8 '
    >
      <FontIcon icon="icon-face-sad" className='text-3xl text-red bg-red-50 rounded-full h-[56px] w-[56px] flex items-center justify-center'/>
      <Text size={SIZE_ENUM.LG} className='mt-6 text-black dark:text-white leading-7' semiBold>{localization.pageNotFound}</Text>
      <Text size={SIZE_ENUM.MD} className='text-grayLight-850 dark:text-white text-center'>{localization.thePageIsNotAccessible}</Text>
      <Button
        className='mt-6 text-[18px] rounded-full px-6'
        style={{height: '52px'}}
        size={SIZE_ENUM.XL}
        onClick={handleRedirect}
      >
        <span className="pl-2">{localization.returnToMerchant}</span>
        <FontIcon icon="icon-arrow-top-right" className="text-xl"/>
      </Button>
    </Container>
  );
};
export default NotFound;
